import Styled from "styled-components";

export const Container = Styled.div`
  padding: 4rem 0 12rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0 12rem 0;
  }
`;

export const Content = Styled.div`
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  gap: 3.5rem;
  width: 100%;
  padding-top: 3rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    width: ${(props) => props.theme.width};
    max-width: calc(100% - 3rem);
    flex-direction: row;
    gap: 2rem;
    margin: 0 auto;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
    gap: 5rem;
  }
`;

export const IllustrationContainer = Styled.div`
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  max-height: 35rem;
  width: 100%;
  padding: 0 2rem;
  margin: 0 auto;
  z-index: 2;
  border-radius: 1.25rem;
  position: relative;

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 0.5;
    padding: 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    flex: 0.44;
  }
`;

export const Illustration = Styled.img`
  position: relative;
  top: 0px;
  left: 0px;
  width: 20.25rem;
  max-width: 100%;
  height: 22.5rem;
  max-height: 100%;
  object-fit: cover;
  object-position: center center;
  opacity: 1;
  transition: opacity 500ms ease 0s;
  border-radius: 1.25rem;

  ${(props) => props.theme.breakpoints.up("large")} {
    width: 100%;
    height: 33rem;
  }
`;

export const Message = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  padding: 0rem 3rem;
    z-index: 2;

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 0.5;
    justify-content: center;
    padding: 0 4.5rem 0 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    gap: 1.875rem;
  }
`;

export const Tagline = Styled.span`
  color: #7F7F7F;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
  letter-spacing: -0.1px;
  align-self: flex-start;

  ${(props) => props.theme.breakpoints.up("large")} {
    font-size: 1.25rem;
    line-height: 1.875rem;
  }
`;

export const Pitch = Styled.div`
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-weight: 400;
  letter-spacing: -0.2px;
  margin-bottom: 1rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    font-size: 1.25rem;
    margin-bottom: 1.875rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    font-size: 1.624rem;
    line-height: 2rem;
  }

  & > p {
    margin: 1rem 0;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }
`;

export const Background = Styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100%);
  padding-bottom: 42rem;
  height: 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    width: 80%;
    padding-bottom: 30rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding-bottom: 58.5%;
  }
`;

export const BackgroundBoxA = Styled(Background)`
  background-color: #1E90FF;
  right: 0;
  border-radius: 1.25rem;
  height: 56rem;
  top: 1.5rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    right: 0;
    bottom: 0;
    height: 35rem;
    top: -1.5rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    height: 46rem;
  }
`;

export const BackgroundBoxB = Styled(Background)`
  background-color: #FAFAFA;
  right: 1rem;
  border-radius: 1.25rem;
  height: 56rem;
  top: 0rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    right: 3rem;
    bottom: 3rem;
    height: 35rem;
    top: -3rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    right: 2rem;
    height: 46rem;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
`;
